import { parsePhoneNumberFromString } from "libphonenumber-js"

export const formatNumber = (number: number, decimal?: number) => {
  if (!number) {
    return "0"
  }
  if (number >= 1000000000) {
    const formattedNumber = (number / 1000000000).toFixed(decimal?.toString() ? decimal : 1)
    return `${formattedNumber} B`
  } else if (number >= 1000000) {
    const formattedNumber = (number / 1000000).toFixed(decimal?.toString() ? decimal : 1)
    return `${formattedNumber} M`
  } else if (number >= 1000) {
    const formattedNumber = (number / 1000).toFixed(decimal?.toString() ? decimal : 1)
    return `${formattedNumber} K`
  } else if (number > 0) {
    return `${number.toFixed(0)}`
  }
  return number.toLocaleString()
}

export const isValidPhoneNumber = (phone: string) => {
  const phoneNumber = parsePhoneNumberFromString(phone)
  return phoneNumber ? phoneNumber.isValid() : false
}
